module.exports = __webpack_public_path__ + "static/media/interiors_panel.0d313ffa.jpg";